import { TextInput } from 'components';
import React, { ComponentProps, memo, useCallback, useState } from 'react';

interface IProps extends ComponentProps<typeof TextInput> {}

const PasswordInputComponent: React.FC<IProps> = ({ ...props }) => {
  const [isPassword, setIsPassword] = useState(true);

  const handleClickIcon = useCallback(() => setIsPassword(prev => !prev), []);

  return (
    <TextInput
      {...props}
      type={isPassword ? 'password' : 'text'}
      rightIcon={{
        name: isPassword ? 'eye' : 'closeEye',
        color: 900,
        clickable: true,
        onClick: handleClickIcon,
      }}
    />
  );
};

export const PasswordInput = memo(PasswordInputComponent);
